export default "__VITE_ASSET__BmG7WGY7__"